import { createSlice } from "@reduxjs/toolkit";
import upperFirst from "lodash/upperFirst";
import cloneDeep from "lodash/cloneDeep";

export const authSlice = createSlice({
  name: "authReducer",
  initialState: {
    token: {
      accessToken: "",
      expiresIn: 0,
      refreshExpiresIn: 0,
      refreshToken: "",
      generatedAt: "",
    },
    participantDetails: {
      guestPpt: true,
      firstName: "",
      lastName: "",
      managedAccount: false,
      ownershipId: "",
      plan: "",
      productId: "",
      productSponsorId: "",
      ssn: "",
    },
  },
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload;
    },
    setTokenGenerated: (state, action) => {
      state.token.generatedAt = action.payload;
    },
    setParticipantDetails: (state, action) => {
      const data = cloneDeep(action.payload);
      const fields = [
        "firstName",
        "middleName",
        "lastName",
        "address1",
        "address2",
        "address3",
        "city",
        "pptStateCountryValue",
        "zipCode",
        "planName",
      ];
      fields.forEach((e) => {
        if (e === "zipCode" && data[e]) {
          data[e] = data[e].toString().padStart(5, "0");
        } else if (data[e]) {
          data[e] = upperFirst(data[e].toLowerCase());
        }
      });
      state.participantDetails = data;
    },
  },
});

export const { setToken, setTokenGenerated, setParticipantDetails } =
  authSlice.actions;
export default authSlice.reducer;
